import { NamespaceProvider, NamespaceContext } from '@ux/namespace-component';
import AccountDelegation from '@ux/account-delegation';
import { events, Customer } from '@ux/header-util';
import ApplicationFooter from '@ux/application-footer';
import AbstractHeader from '@ux/abstract-header';
import BrowserDeprecationBannner from '@ux/browser-deprecation-banner';
import HeaderComponent from './header';
import React from 'react';
import PropTypes from 'prop-types';

function namespace() {
  return {
    namespace: process.env.NAMESPACE // eslint-disable-line no-process-env
  };
}

class Header extends AbstractHeader {

  createCustomer() {
    return new Customer(this.props);
  }

  render() {
    const childProps = { ...this.props, ...this.state };

    return (
      <NamespaceProvider { ...namespace() }>
        <NamespaceContext.Consumer>
          { context =>
            <div className={ context.namespace(this.classNames({
              loaded: this.isBrowser
            })) }>
              <BrowserDeprecationBannner { ...childProps } />
              <AccountDelegation
                market={ childProps.market }
                messages={ childProps.messages }
                action={ childProps.urls.sso.exitDelegation.href }
                restoreCookie={ childProps.urls.sso.restoreCookie.href }
                customer={ this.customer } />
              <HeaderComponent { ...childProps } />
            </div>
          }
        </NamespaceContext.Consumer>
      </NamespaceProvider>
    );
  }
}

Header.propTypes = {
  messages: PropTypes.object.isRequired,
  market: PropTypes.string.isRequired,
  urls: PropTypes.object.isRequired
};

class Footer extends React.Component {
  componentDidMount() {
    events.emit('mount', 'footer', this);
    events.emit('mount:footer', this);
  }

  render() {
    return (
      <NamespaceProvider { ...namespace() }>
        <ApplicationFooter { ...this.props } />
      </NamespaceProvider>
    );
  }
}

export {
  Header,
  Footer
};


